export enum FileStatus {
	LOADING = 'loading',
	LOADED = 'loaded',
}
